import React, { useState } from "react";
import "./sidebar.scss";
import { NavLink, useNavigate } from "react-router-dom";
import DashboardRoundedIcon from "@mui/icons-material/DashboardRounded";
import PeopleAltRoundedIcon from "@mui/icons-material/PeopleAltRounded";
import StoreRoundedIcon from "@mui/icons-material/StoreRounded";
import HotelRoundedIcon from "@mui/icons-material/HotelRounded";
import EventNoteRoundedIcon from "@mui/icons-material/EventNoteRounded";
import TerrainRoundedIcon from "@mui/icons-material/TerrainRounded";
import AccountCircleRoundedIcon from "@mui/icons-material/AccountCircleRounded";
import SettingsRoundedIcon from "@mui/icons-material/SettingsRounded";
import RestaurantIcon from '@mui/icons-material/Restaurant';
import HelpOutlineRoundedIcon from "@mui/icons-material/HelpOutlineRounded";
import LogoutRoundedIcon from "@mui/icons-material/LogoutRounded";
import { ContactMail } from "@mui/icons-material";
import logo from "../../assets/logo.png";
import axios from "axios";
import { useContext } from "react";
import { AuthContext } from "../../context/AuthContext";
import FeedIcon from '@mui/icons-material/Feed';
import RateReviewRoundedIcon from "@mui/icons-material/RateReviewRounded";


const menuItems = [
  {
    section: "main",
    items: [
      { name: "Dashboard", icon: <DashboardRoundedIcon />, path: "/", badge: "5" },
      { name: "Users", icon: <PeopleAltRoundedIcon />, path: "/users" },
      { name: "Cafes & Restaurants", icon: <RestaurantIcon />, path: "/cafes" },
      { name: "Hotels & Riads", icon: <HotelRoundedIcon />, path: "/hotels" },
      { name: "Events", icon: <EventNoteRoundedIcon />, path: "/events" },
      { name: "Plans", icon: <TerrainRoundedIcon />, path: "/plans" },
      { name: "Blogs", icon: <FeedIcon />, path: "/blogs" },
      { name: "Contact Messages", icon: <ContactMail />, path: "/contact" },
      { name: "Reviews", icon: <RateReviewRoundedIcon />, path: "/reviews" },
    ],
  },
  {
    section: "general",
    items: [
      { name: "Logout", icon: <LogoutRoundedIcon />, path: "/logout" },
    ],
  },
];

const Sidebar = () => {
  const [hoveredItem, setHoveredItem] = useState(null);
  const { dispatch } = useContext(AuthContext);
  const navigate = useNavigate();

  const handleLogout = async () => {
    try {
      await axios.post("https://api.moroccool.com/api/auth/logout", {}, { withCredentials: true });
      dispatch({ type: "LOGOUT" });
      localStorage.clear();
      sessionStorage.clear();
      navigate("/login");
    } catch (err) {
      console.error("Logout failed:", err);
    }
  };

  return (
    <div className="sidebar">
      <div className="sidebar-header">
        <img src={logo} alt="Logo" className="logo" />
      </div>

      <div className="sidebar-divider" />

      <div className="menu">
        {menuItems.map((section, sectionIndex) => (
          <div key={sectionIndex} className={`menu-section ${section.section}`}>
            {section.section === "main" && <div className="section-label">Menu</div>}
            {section.section === "general" && <div className="section-label">General</div>}

            {section.items.map((item, itemIndex) => (
              <div
                key={itemIndex}
                className="menu-item-wrapper"
                onMouseEnter={() => setHoveredItem(`${sectionIndex}-${itemIndex}`)}
                onMouseLeave={() => setHoveredItem(null)}
              >
                <NavLink
                  to={item.path}
                  className={({ isActive }) => `menu-item ${isActive ? "active" : ""}`}
                  onClick={item.name === "Logout" ? (e) => { e.preventDefault(); handleLogout(); } : undefined}
                >
                  <div className="icon-container">
                    {item.icon}
                    {item.badge && <span className="badge">{item.badge}</span>}
                  </div>
                </NavLink>

                {hoveredItem === `${sectionIndex}-${itemIndex}` && (
                  <div className="tooltip">{item.name}</div>
                )}
              </div>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
};

export default Sidebar;